export let ResetPhoneNumberStep;
(function (ResetPhoneNumberStep) {
  ResetPhoneNumberStep["ResetPhoneNumber"] = "ResetPhoneNumber";
  ResetPhoneNumberStep["VerifyResetPhoneNumber"] = "VerifyResetPhoneNumber";
  ResetPhoneNumberStep["ChangePhoneNumber"] = "ChangePhoneNumber";
})(ResetPhoneNumberStep || (ResetPhoneNumberStep = {}));